
import { Options } from "vue-class-component";
import LoginWithSocialNetwork from "@/components/loginWithSocialNetwork/LoginWithSocialNetwork.vue";
import Base from "../../components/base/Base.vue";
@Options({
  components: {
    LoginWithSocialNetwork
  }
})
export default class RightPanel extends Base {
  public username = "";
  public password = "";
}
